export default function GoodsItem (props) {
  const {
    mainId,
    displayName,
    displayDescription,
    price: { regularPrice },
    displayAssets: [{ full_background: backgroundUrl } = {}] = [],
    addOrder = Function.prototype
  } = props;



  return (
    <div className="card" id={mainId}>
      <div className="card-image">
        <img src={backgroundUrl} />
      </div>
      <div className="card-content">
        <span className="card-title">{displayName}</span>
        <p style={{ minHeight: '45px' }}>{displayDescription}</p>
      </div>
      <div className="card-action">
        <button className="btn" onClick={() => addOrder({
          mainId,
          displayName,
          regularPrice
        })}>Купить</button>
        <span className="right" style={{ fontSize: '1.8rem ' }}>{regularPrice} руб.</span>
      </div>
    </div >
  )
}